import type { AxiosRequestConfig, AxiosResponse } from 'axios';
import { request } from '@/api/httpClient';
import { ApiRequestError, type ApiEnvelope } from '@/api/errors';
import type { RequestPolicy } from '@/api/policy';

// База для доменных сервисов. Даёт типизированный доступ к транспорту (request) и распаковку
// конверта {success,error,error_description,data}. Публичные методы сервисов возвращают чистые
// доменные данные; status/конверт сервис читает внутри через AxiosResponse.
export abstract class BaseService {
  protected request<T>(
    requestConfig: AxiosRequestConfig,
    policy?: RequestPolicy,
  ): Promise<AxiosResponse<T>> {
    return request<T>(requestConfig, policy);
  }

  /** Распаковать конверт: бросить ApiRequestError на success:false / пустые данные, иначе вернуть data. */
  protected unwrap<T>(envelope: ApiEnvelope<T>, status?: number): T {
    this.ensureSuccess(envelope, status);
    if (envelope?.data == null) {
      throw new ApiRequestError('Empty response data', { status });
    }
    return envelope.data;
  }

  /**
   * Для void-мутаций: бросить ApiRequestError, если бэкенд вернул логическую ошибку (`success:false`).
   * ВАЖНО: многие наши эндпоинты отдают такие ошибки c HTTP 200 (напр. «нельзя удалить единственный
   * счёт») — транспорт их не отловит, поэтому конверт обязан проверять сам сервис. Данных не требует.
   */
  protected ensureSuccess(envelope: ApiEnvelope | undefined, status?: number): void {
    if (envelope?.success === false) {
      throw new ApiRequestError(envelope.error_description ?? envelope.error ?? 'Request failed', {
        status,
        code: envelope.error,
        description: envelope.error_description,
      });
    }
  }
}
